var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.774,
    height: 18.958,
    viewBox: "0 0 18.774 18.958",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_Hover_16px",
    transform: "translate(-408.012 -127.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160577",
    "data-name": "Group 160577",
    transform: "translate(408.421 128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_Outline_24px",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1085",
    "data-name": "Rectangle 1085",
    width: 17.688,
    height: 18,
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1086",
    "data-name": "Rectangle 1086",
    width: 7.092,
    height: 7.092,
    rx: 1,
    transform: "translate(0.393 0.376)",
    fill: "#adc7ff",
    stroke: "#165cf3",
    strokeWidth: 1.57
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1087",
    "data-name": "Rectangle 1087",
    width: 7.092,
    height: 7.092,
    rx: 1,
    transform: "translate(10.413 0.376)",
    fill: "#adc7ff",
    stroke: "#165cf3",
    strokeWidth: 1.57
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1088",
    "data-name": "Rectangle 1088",
    width: 7.092,
    height: 7.092,
    rx: 1,
    transform: "translate(0.376 10.673)",
    fill: "#adc7ff",
    stroke: "#165cf3",
    strokeWidth: 1.57
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M22.02,15.48c.009.052.017.1.026.148",
    transform: "translate(-4.585 -3.385)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeWidth: 1.57
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M21.028,19.363a1.667,1.667,0,0,1-1.842,1.608h-3.45a1.825,1.825,0,0,1-1.825-1.825V15.7a1.825,1.825,0,0,1,1.825-1.825h3.45A1.835,1.835,0,0,1,20.915,15.1",
    transform: "translate(-3.523 -3.206)",
    fill: "#f49b31",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120",
    "data-name": "Ellipse 120",
    cx: 0.495,
    cy: 0.495,
    r: 0.495,
    transform: "translate(17.009 13.811)",
    fill: "#165cf3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardDarkIcon);
export default __webpack_public_path__ + "static/media/dashboard-dark-icon.785e4fb9c26a25c88597e18bc03483e8.svg";
export { ForwardRef as ReactComponent };